import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useWindowSize } from 'react-use';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { ReduxState } from 'redux/types';

interface Props {
    companyName: string;
    assessmentYear: number | null;
    setIsCompanyDialogOpen: Dispatch<SetStateAction<boolean>>;
}

const Header = ({ companyName, assessmentYear, setIsCompanyDialogOpen }: Props) => {
    const { width } = useWindowSize();
    const isMobile = width <= 900;

    const userInfo = useSelector((state: ReduxState) => state.user);
    const isCustomer = userInfo.type === 'customer';

    const { t } = useTranslation();

    return (
        <>
            <div style={{ display: isMobile ? 'block' : 'flex', marginTop: '-8px', marginBottom: '8px' }}>
                <Typography variant='h2' style={{ fontSize: isMobile ? '3em' : '3.6em', textAlign: isMobile ? 'center' : 'left' }}>
                    {companyName}
                </Typography>
                <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '18px' }}>
                    <div style={{ flexGrow: 1 }} />
                    <Typography variant='h2' style={{ fontSize: '2em', marginBottom: '4px', textAlign: isMobile ? 'center' : 'left' }}>
                        {assessmentYear ? <>{t('pages.plastic_assessment.year')} {assessmentYear}</> : null}
                    </Typography>
                </div>

                <div style={{ flex: 1, flexGrow: 1 }} />

                {!isCustomer && (
                    <Button variant={'contained'} color='primary' onClick={() => setIsCompanyDialogOpen(true)} style={{ height: 'fit-content', margin: 'auto', flexGrow: 0, marginTop: isMobile ? '10px' : 'auto', marginBottom: isMobile ? '10px' : 'auto', display: isMobile ? 'block' : undefined, }}>
                        Dettagli cliente
                    </Button>
                )}

            </div>
        </>
    );
};

export default Header;